import FarloUiRevolverCarousel from './farlo-ui-revolver-carousel.js';

class FarloUiLightbox {
	constructor(element, options = {}) {
		this.element = element;
		this.options = options;

		this.currentCarouselIndex = 0;
		this.carouselEnabled = this.checkCarouselEnabled();

		if (this.carouselEnabled) {
			this.carouselItems = Array.from(this.element.children);
			this.carouselItems.forEach((item, index) => {
				item.addEventListener('click', (event) => {
					event.preventDefault();
					this.currentCarouselIndex = index;
					this.openLightbox();
				});
			});
		} else {
			this.element.addEventListener('click', (event) => {
				event.preventDefault();
				this.openLightbox();
			});
		}

		this.initialiseLightboxContainer();
		this.lightbox = document.querySelector('.farlo-ui-lightbox');
		this.lightboxContent = this.lightbox.querySelector('.farlo-ui-lightbox__content');
		this.lightboxContentInner = this.lightbox.querySelector('.farlo-ui-lightbox__content-inner');
		this.lightboxImage = this.lightbox.querySelector('.farlo-ui-lightbox__image');
		this.closeButton = this.lightbox.querySelector('.farlo-ui-lightbox__close');
		this.backdrop = this.lightbox.querySelector('.farlo-ui-lightbox__backdrop');

		this.closeButton.addEventListener('click', this.closeLightbox.bind(this));
		this.backdrop.addEventListener('click', (event) => {
			if (event.target === this.backdrop) {
				this.closeLightbox();
			}
		});
		this.lightbox.addEventListener('keydown', this.handleKeydown.bind(this));
		this.element.setAttribute('aria-haspopup', 'dialog');
		this.lightbox.setAttribute('role', 'dialog');
		this.lightbox.setAttribute('aria-modal', 'true');
		this.lightbox.setAttribute('aria-hidden', 'true');
		this.closeButton.setAttribute('aria-label', 'Close Lightbox');
	}

	checkCarouselEnabled() {
		const parentElement = this.element.closest('.farlo-ui-revolver-carousel--enabled');
		return parentElement ? true : false;
	}

	helperIsImageType(src) {
		return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(src);
	}

	helperValueNullOrUndefined(checkedElement) {
		return checkedElement && typeof checkedElement !== 'undefined' && checkedElement.value && typeof checkedElement.value !== 'undefined' && checkedElement.value !== '';
	}

	initialiseLightboxContainer() {
		if (!document.querySelector('.farlo-ui-lightbox')) {
			const div = document.createElement('div');
			const divInner = document.createElement('div');
			const divImage = document.createElement('div');
			const divInnerContent = document.createElement('div');
			const divClose = document.createElement('button');
			const divBackdrop = document.createElement('div');
			div.className = 'farlo-ui-lightbox';
			divInner.className = 'farlo-ui-lightbox__inner';
			divImage.className = 'farlo-ui-lightbox__image';
			divInnerContent.className = 'farlo-ui-lightbox__content-inner';
			divClose.className = 'farlo-ui-lightbox__close';
			divBackdrop.className = 'farlo-ui-lightbox__backdrop';

			divClose.textContent = 'Close';

			// Append elements to create the lightbox container
			div.appendChild(divBackdrop);
			div.appendChild(divInner);
			divInner.appendChild(divImage);
			divInner.appendChild(divInnerContent);
			divInner.appendChild(divClose);
			document.body.appendChild(div);

		}
	}

	openLightbox() {
		let content = '';
		const hiddenInput = this.element.querySelector('.farlo-ui-lightbox__html');
		if (hiddenInput && hiddenInput.value) {
			content = hiddenInput.value;
		} else {
			content = this.generateCarouselContent(this.carouselEnabled ? this.element : this.element.parentNode, this.options.carousel);
		}

		// Parse the content and separate the image
		const parser = new DOMParser();
		const doc = parser.parseFromString(content, 'text/html');
		const images = doc.querySelectorAll('img');
		const imageHtml = Array.from(images).map(img => img.outerHTML).join('');
		const otherContent = doc.body.innerHTML;

		this.lightboxContentInner.innerHTML = otherContent;



		if (this.options.carousel && this.carouselEnabled) {
			const carouselElement = this.lightboxContentInner.querySelector('.farlo-ui-revolver-carousel');
			if (carouselElement) {
				this.carousel = new FarloUiRevolverCarousel(carouselElement, { initialIndex: this.currentCarouselIndex });
			}
		}

		this.previousActiveElement = document.activeElement;

		this.lightbox.classList.add('farlo-ui-lightbox--active');
		document.body.classList.add('farlo--lightbox');
		this.lightbox.removeAttribute('aria-hidden');
		this.trapFocus();
		if (this.closeButton) {
			this.closeButton.focus();
		}
	}

	closeLightbox() {
		this.lightbox.classList.remove('farlo-ui-lightbox--active');
		document.body.classList.remove('farlo--lightbox');

		setTimeout(() => {
			if (this.lightboxContentInner) {
				this.lightboxContentInner.innerHTML = '';
			}
			if (this.lightboxImage) {
				this.lightboxImage.innerHTML = '';
			}
			this.lightbox.setAttribute('aria-hidden', 'true');
			if (this.previousActiveElement) {
				this.previousActiveElement.focus();
			}
		}, 300);
	}

	handleKeydown(event) {
		if (event.key === 'Escape') {
			this.closeLightbox();
		}
		if (event.key === 'Tab') {
			this.trapFocus(event);
		}
	}

	trapFocus(event) {
		const focusableElements = this.lightbox.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select');
		const firstFocusableElement = focusableElements[0];
		const lastFocusableElement = focusableElements[focusableElements.length - 1];

		if (event) {
			if (event.shiftKey) {
				// Shift + Tab
				if (document.activeElement === firstFocusableElement) {
					lastFocusableElement.focus();
					event.preventDefault();
				}
			} else {
				// Tab
				if (document.activeElement === lastFocusableElement) {
					firstFocusableElement.focus();
					event.preventDefault();
				}
			}
		} else {
			firstFocusableElement.focus();
		}
	}

	generateCarouselContent(element, isCarousel) {
		let content = '';

		if (isCarousel) {
			content += '<div class="farlo-ui-revolver-carousel">';
			Array.from(element.children).forEach((item, index) => {
				content += `
                    <div class="farlo-ui-revolver-carousel__chamber">
                        ${item.innerHTML}
                    </div>
                `;
			});
			content += '</div>';
		} else {
			content += element.innerHTML;
		}

		return content;
	}
}

export default FarloUiLightbox;
